var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyFoodImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7438",
    "data-name": "Group 7438",
    transform: "translate(12748 5499)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(-12784 -5921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1971",
    "data-name": "Rectangle 1971",
    transform: "translate(36 422)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 53,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 54,
    height: 52,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2124",
    "data-name": "Rectangle 2124",
    transform: "translate(40 426)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 45,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 44,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M7.5,4.5h21a3,3,0,0,1,3,3v21a3,3,0,0,1-3,3H7.5a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3Z",
    transform: "translate(45.5 430.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M.625-443.077c-.067.073-.07.1-.176,1.884A7.018,7.018,0,0,0,.4-439.4a1.608,1.608,0,0,0,.7.927.746.746,0,0,1,.28.483c.009.073-.018.513-.061.978-.152,1.61-.307,4.241-.286,4.834a.977.977,0,0,0,.24.76.568.568,0,0,0,.872.036,1.211,1.211,0,0,0,.292-.993c-.006-.143-.027-.559-.043-.927-.055-1.124-.149-2.531-.246-3.594-.049-.562-.082-1.06-.07-1.124.043-.237.143-.371.462-.608a1.365,1.365,0,0,0,.544-.963c.012-.17-.155-3.135-.188-3.345a.207.207,0,0,0-.249-.188.154.154,0,0,0-.161.1,5.016,5.016,0,0,0,.018,1.4,11.788,11.788,0,0,1,.033,1.391.243.243,0,0,1-.313.143.266.266,0,0,1-.14-.1,10.859,10.859,0,0,1-.073-1.428l-.033-1.361-.073-.076a.25.25,0,0,0-.368.018c-.052.07-.058.182-.085,1.367-.018.711-.046,1.343-.064,1.4a.235.235,0,0,1-.307.179c-.2-.073-.2-.076-.118-1.75.03-.6.049-1.115.039-1.139A.241.241,0,0,0,.625-443.077Z",
    transform: "translate(-12730.382 -5035.777)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hot-food",
    transform: "translate(-12724.883 -5479.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M139.54-480.824a.841.841,0,0,0-.206.2,1.5,1.5,0,0,0-.334.971,1.537,1.537,0,0,0,.4,1.047.787.787,0,0,1,.255.581.715.715,0,0,1-.174.486.568.568,0,0,0-.152.328.428.428,0,0,0,.217.353c.212.109.407.043.589-.2a1.5,1.5,0,0,0,.334-.971,1.537,1.537,0,0,0-.4-1.047.787.787,0,0,1-.255-.581.715.715,0,0,1,.174-.486.568.568,0,0,0,.152-.328.428.428,0,0,0-.217-.353A.385.385,0,0,0,139.54-480.824Z",
    transform: "translate(-135.23 480.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M229.54-480.824a.841.841,0,0,0-.206.2,1.5,1.5,0,0,0-.334.971,1.537,1.537,0,0,0,.4,1.047.787.787,0,0,1,.255.581.715.715,0,0,1-.174.486.568.568,0,0,0-.152.328.428.428,0,0,0,.217.353c.212.109.407.043.589-.2a1.5,1.5,0,0,0,.334-.971,1.537,1.537,0,0,0-.4-1.047.787.787,0,0,1-.255-.581.715.715,0,0,1,.174-.486.568.568,0,0,0,.152-.328.428.428,0,0,0-.217-.353A.385.385,0,0,0,229.54-480.824Z",
    transform: "translate(-222.788 480.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M319.54-480.824a.84.84,0,0,0-.206.2,1.5,1.5,0,0,0-.334.971,1.537,1.537,0,0,0,.4,1.047.787.787,0,0,1,.255.581.715.715,0,0,1-.174.486.568.568,0,0,0-.152.328.428.428,0,0,0,.217.353c.212.109.407.043.589-.2a1.5,1.5,0,0,0,.334-.971,1.537,1.537,0,0,0-.4-1.047.787.787,0,0,1-.255-.581.715.715,0,0,1,.174-.486.568.568,0,0,0,.152-.328.428.428,0,0,0-.217-.353A.385.385,0,0,0,319.54-480.824Z",
    transform: "translate(-310.346 480.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M.257-270.943a.371.371,0,0,0-.16.168c-.054.1-.057.141-.043.44a5.694,5.694,0,0,0,.117.874l.016.09H13.8l.016-.09a5.694,5.694,0,0,0,.117-.874c.014-.3.011-.336-.043-.44a.362.362,0,0,0-.166-.171C13.615-271,13.577-271,6.986-271,.439-271,.357-271,.257-270.943Z",
    transform: "translate(-0.047 276.695)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M15.181-180.818a5.4,5.4,0,0,0,.768,1.194,5.168,5.168,0,0,0,1.693,1.324l.3.152v.448c0,.518.027.605.212.711l.109.06h3.367c3.324,0,3.37,0,3.476-.054.187-.095.217-.193.217-.716v-.445l.288-.141a5.425,5.425,0,0,0,1.772-1.408,5.69,5.69,0,0,0,.719-1.15l.068-.155H15.1Z",
    transform: "translate(-14.692 189.137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFoodImg);
export default __webpack_public_path__ + "static/media/emptyFoodImg.4adb0debf6c51ff6300968cadedf7730.svg";
export { ForwardRef as ReactComponent };